import { CSSObject } from "styled-components";
import { vfxTheme } from "../Theme/theme";

interface ConfirmationStyles {
  confirmationContainer: CSSObject;
  btnClose: CSSObject;
  cancelButton: CSSObject;
  confirmButton: CSSObject;
  contentBox: CSSObject;
  flex: CSSObject;
  text: CSSObject;
  title: CSSObject;
}
const useConfirmationStyles = (): ConfirmationStyles => {
  
  return {
    confirmationContainer: {
      margin: `${vfxTheme.spaceUnits.sp03}px`,
      minWidth: "428px",
    },
    btnClose: {
      position: "absolute",
      right: `${vfxTheme.spaceUnits.sp01 * 5}px`,
      top: `${vfxTheme.spaceUnits.sp01 * 4}px`,
      cursor: "pointer",
    },
    cancelButton: {
      backgroundColor: vfxTheme.palette.background.default,
      color: vfxTheme.palette.blues.b500,
      fontWeight: vfxTheme.fontWeights.bold,
      marginTop: `${vfxTheme.spaceUnits.sp02}px`,
    },
    confirmButton: {
      backgroundColor: vfxTheme.palette.primary.main,
      color: vfxTheme.palette.background.default,
      fontWeight: vfxTheme.fontWeights.bold,
      marginTop: `${vfxTheme.spaceUnits.sp02}px`,
    },
    contentBox: {
      marginBottom: `${vfxTheme.spaceUnits.sp03 + 1}px`,
      marginTop: `${vfxTheme.spaceUnits.sp01 + 3}px`,
    },
    flex: {
      display: "flex",
      justifyContent: "space-between",
    },
    text: {
      color: vfxTheme.palette.black,
      fontSize: `${vfxTheme.spaceUnits.sp02 + 4}px`,
    },
    title: {
      alignSelf: "center",
      color: vfxTheme.palette.text.primary,
      fontFamily: `${vfxTheme.fontFamily}, sans-serif`,
      fontWeight: vfxTheme.fontWeights.semiBold,
      fontSize: `${vfxTheme.spaceUnits.sp03 + 3}px`,
      lineHeight: `${vfxTheme.spaceUnits.sp01 * 5}px`,
      width: "100%",
    },
  };
};
export default useConfirmationStyles;
